import React, { useContext, useEffect, useRef } from 'react';
import { useTheme } from 'styled-components';
import { ProgramCategory } from '@gql/generated';

/*
  WE DRAW AN INDICATOR FOR EACH PHASE
  BECAUSE ON MOBILE THE LIST OF VIDEOS ARE DISPLAYED IN A HORIZONTAL SLIDER
*/

type Props = {
  children: React.ReactNode;
  selector?: string;
  programCategory: ProgramCategory;
};
const VideosListWithIndicator = ({
  children,
  selector = '.phaseVideosWrapper',
  programCategory,
  ...otherProps
}: Props) => {
  const _ref = useRef<HTMLDivElement>();
  const theme = useTheme();

  useEffect(() => {
    // we query based on selector to keep line scoped...
    const el = _ref?.['current'].querySelector(selector);
    if (el) {
      const wrapperBox = el?.getBoundingClientRect();
      const frag = document.createDocumentFragment();
      el?.querySelectorAll('.videoBox').forEach(
        (item: HTMLElement, index, arr) => {
          const videoRect = item.getBoundingClientRect();
          const videometa = item.dataset;
          // if (videometa.videoLast !== 'true') {
          const line = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'line'
          );
          line.setAttribute('x1', '0');
          line.setAttribute('x2', '0');
          line.setAttribute('y1', `${videoRect.y - wrapperBox.y}`);
          if (arr[index + 1]) {
            const nextVideo = arr[index + 1].getBoundingClientRect();
            line.setAttribute('y2', `${nextVideo.y - wrapperBox.y}`);
          } else {
            line.setAttribute('y2', `${videoRect.y + videoRect.height}`);
          }
          const SIDE_INDICATOR_WIDTH = 4;
          line.setAttribute('stroke-width', `${SIDE_INDICATOR_WIDTH}`);
          // we style depending on the videoBox data-*
          const color =
            programCategory === ProgramCategory['Challenges']
              ? theme.colors.primary.green
              : theme.colors.primary['blue-2'];
          if (videometa.videoFinished === 'true') {
            line.setAttribute('stroke', color);
          } else {
            line.setAttribute('stroke', '#F1F1F1');
          }
          if (videometa.videoBonus === 'true') {
            line.setAttribute('stroke-dasharray', '5 3');
          }
          frag.appendChild(line);
          // }
        }
      );
      const svg = el?.querySelector('.phase-videos-indicator');
      if (svg) {
        requestAnimationFrame(() => {
          svg.innerHTML = '';
          svg.appendChild(frag);
        });
      } else {
        const svg = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg'
        );
        requestAnimationFrame(() => {
          svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
          svg.setAttribute('class', 'phase-videos-indicator');
          el.appendChild(svg);
          svg.appendChild(frag);
        });
      }
    }
  }, []);

  return (
    <div ref={_ref} {...otherProps}>
      {children}
    </div>
  );
};

export default VideosListWithIndicator;
